import { baseApi } from "../../../../core/data/rtk/baseQuery";
import { ApiResponseType } from "../../../../core/data/rtk/apiResponseType";
import { RegistrationFeeConfigResponseType, Data } from "../types/registrationFeeConfigResponse";
import { RegistrationFeeConfigPayloadType } from "../types/registrationFeeConfigRequest";

export const registrationFeeApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllRegistrationFee: builder.query<
      ApiResponseType<Data>,
      { size?: number; search?: string; page?: number }
    >({
      query: (params) => {
        const queryParams = new URLSearchParams();
        if (params?.size) queryParams.append("size", params.size.toString());
        if (params?.search) queryParams.append("search", params.search);
        if (params?.page) queryParams.append("page", params.page.toString());

        return `course-registration-fee/get-all?${queryParams.toString()}`;
      },
      providesTags: ["RegistrationFee"],
    }),
    addRegistrationFee: builder.mutation<
      ApiResponseType<{ registrationfee: RegistrationFeeConfigResponseType }>,
      RegistrationFeeConfigPayloadType
    >({
      query: (payload) => ({
        url: "course-registration-fee/save",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["RegistrationFee"],
    }),
    getRegistrationFeeById: builder.query<
      ApiResponseType<{ registrationfee: RegistrationFeeConfigResponseType }>,
      { id: string }
    >({
      query: ({ id }) => `course-registration-fee/get/${id}`,
      providesTags: ["RegistrationFee"],
    }),
    updateRegistrationFee: builder.mutation<
      ApiResponseType<{ registrationfee: RegistrationFeeConfigResponseType }>,
      { id: string; payload: RegistrationFeeConfigPayloadType }
    >({
      query: ({ id, payload }) => ({
        url: `course-registration-fee/update/${id}`,
        method: "PUT",
        body: payload,
      }),
      invalidatesTags: ["RegistrationFee"],
    }),
    deleteRegistrationFee: builder.mutation<
      ApiResponseType<{ deleted: true }>,
      { id: string }
    >({
      query: ({ id }) => ({
        url: `course-registration-fee/delete/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["RegistrationFee"],
    }),
    attachRegistrationFeeCenters: builder.mutation<
      ApiResponseType<{ registrationfee: RegistrationFeeConfigResponseType }>,
      { id: string; payload: { center_ids: number[] } }
    >({
      query: ({ id, payload }) => ({
        url: `course-registration-fee/attach-to-centers/${id}`,
        method: "PUT",
        body: payload,
      }),
      invalidatesTags: ["RegistrationFee", "Centers"],
    }),
    detachRegistrationFeeCenters: builder.mutation<
      ApiResponseType<{ registrationfee: RegistrationFeeConfigResponseType }>,
      { id: string; payload: { center_ids: number[] } }
    >({
      query: ({ id, payload }) => ({
        url: `course-registration-fee/detach-from-centers/${id}`,
        method: "PUT",
        body: payload,
      }),
      invalidatesTags: ["RegistrationFee", "Centers"],
    }),
  }),
});

export const {
  useGetAllRegistrationFeeQuery,
  useAddRegistrationFeeMutation,
  useGetRegistrationFeeByIdQuery,
  useUpdateRegistrationFeeMutation,
  useDeleteRegistrationFeeMutation,
  useAttachRegistrationFeeCentersMutation,
  useDetachRegistrationFeeCentersMutation,
} = registrationFeeApi;
